import React, { useEffect, useRef } from 'react';
import { createChart } from 'lightweight-charts';

const CandleChart = ({ctx, data }) => {
    const chartContainerRef = useRef();
    const chartRef = useRef();

    useEffect(() => {
        const chart = createChart(chartContainerRef.current, {
            layout: {
                background: { color: '#ffffff' },
                textColor: '#000',
            },
            timeScale: {
                timeVisible: true,
                secondsVisible: true,
            },
        });

        chartRef.current = chart;


        const candleSeries = chart.addCandlestickSeries();

        const rawData = data;

        const length = rawData.t.length;
        if (
            rawData.o.length !== length ||
            rawData.h.length !== length ||
            rawData.l.length !== length ||
            rawData.c.length !== length
        ) {
            throw new Error("All arrays must be of the same length");
        }

        const candles = rawData.t.map((t, i) => ({
            time: t, // t به ثانیه است
            open: rawData.o[i],
            high: rawData.h[i],
            low: rawData.l[i],
            close: rawData.c[i],
        }));



        candleSeries.setData(candles);



        return () => chart.remove();
    }, [data]);

    return <div ref={chartContainerRef} style={{ width: '100%', height: '100%' }} />;
};

export default CandleChart;
